import {
    useContext, useState, useEffect
} from 'react';
import {
    SubOrgContext
} from 'shared/context/SubOrganizationContext';
import {
    PageContent, PageContentHeader, PageContentHeaderText, PageContentHeaderTitle, PageDescription, PageHeader, PageHeaderAction, PageLayout, PageSubTitle, PageTitle, PageTitles
} from 'shared/components/NewDesignComponents/PageLayout';
import {
    Button
} from 'shared/components/ui/button';
import Collection, {
    CreateNewCollectionDialog
} from '../backup/Collection';

export default function KnowledgeBuilder() {

    const [openModal, setOpenModal] = useState(false);

    const {
        collections,
        collectionLoading,
        vectorIndex,
        hasMilvusCollection,
        actions,
        fetchCollections,
    } = useContext(SubOrgContext);
    useEffect(() => {
        fetchCollections();
    }, [fetchCollections]);

    return (
        <PageLayout>
            <PageHeader>
                <PageTitles>
                    <PageTitle>
                        Create your Enterprise
                    </PageTitle>
                    <PageSubTitle>
                        Knowledge Base
                    </PageSubTitle>
                    <PageDescription>
                        Centralize your organization's knowledge with AI-powered insights. Build a dynamic, accessible repository that empowers your teams to collaborate, innovate, and execute with confidence.
                    </PageDescription>
                </PageTitles>
                <PageHeaderAction>
                    <Button onClick={() => setOpenModal(true)} className='w-full'> Add new collection </Button>
                </PageHeaderAction>
            </PageHeader>
            <PageContent>
                <PageContentHeader>
                    <PageContentHeaderTitle>Knowledge Builder:</PageContentHeaderTitle>
                    <PageContentHeaderText>Manage your Enterprise Knowledge Base</PageContentHeaderText>
                </PageContentHeader>
                <div className="w-full mx-auto p-2 md:p-6">
                    <Collection
                        collections={collections}
                        collectionLoading={collectionLoading}
                        hasMilvusCollection={hasMilvusCollection}
                        vectorIndex={vectorIndex}
                        actions={actions} />
                </div>
                {/* create new collection dialog */}
                <CreateNewCollectionDialog
                    hasMilvusCollection={hasMilvusCollection}
                    actions={actions} openModal={openModal}
                    setOpenModal={setOpenModal}
                    vectorIndex={vectorIndex} />
            </PageContent>
        </PageLayout>
    );
}
